<!-- eslint-disable vue/no-unused-components -->
<!--

   V 0.1.0 = 2023-02-22
      - Added the ability to test components

-->
<template>
  <div v-if="!test">
    <Login v-if="!show" />

    <Main v-if="show" @user-logout="userLogout" />

    <!-- <router-view></router-view> -->
  </div>
  <div v-else>
    <v-app id="app">
      <!-- <CalendarTrips /> -->
      <router-view v-on:update-cart="updateCart"></router-view>
    </v-app>
  </div>
</template>
<script>
/* eslint-disable vue/no-unused-components */
import Login from './lib/v1/pages/Login'

import Main from './pages/v1/Main'
import VehicleSelect from './pages/v1/VehicleSelect'
import MapFollow from './pages/v1/MapFollow'
import CalendarTrips from './pages/v1/CalendarTrips'

export default {
  data () {
    return {
      show: false,
      test: false // false, true
    }
  },
  created: function () {
    if (this.$debug) {
      var name = ''
      var pass = ''
      var page = ''
      var filter = ''
      // debugger;

      console.log('App.vue:created():')

      if (typeof this.$route.params.name !== 'undefined') {
        name = this.$route.params.name
        console.log('name:' + this.$route.params.name)
      }

      if (typeof this.$route.params.pass !== 'undefined') {
        pass = this.$route.params.pass
        console.log('pass:' + this.$route.params.name)
      }

      if (typeof this.$route.params.page !== 'undefined') {
        page = this.$route.params.page
        console.log('page:' + this.$route.params.page)
      }

      if (typeof this.$route.params.filter !== 'undefined') {
        filter = this.$route.params.filter
        console.log('filter:' + this.$route.params.page)
      }

      // :page/:filter/:description/:name/:pass
    }
  },
  mounted: function () {
    var isLoggedIn = this.$store.state.isLoggedIn

    if (this.$debug) {
      console.log(`isLoggedIn: ${isLoggedIn}`)
    }

    this.show = isLoggedIn
    var path = ''
    if (this.test) {
      // this.$router.push(`/`);
      path = '/calendar-trips-select/352093086342697/VVM100GP/2023-03-09'
      this.$router
        .push(path)
      /**
               *   2023-03-27
               *   Catch handles the error: Avoided redundant navigation to current location
               *
               *   https://stackoverflow.com/questions/62462276/how-to-solve-avoided-redundant-navigation-to-current-location-error-in-vue
               *
               */
        .catch(() => { })
    }
  },
  /* methods: {
        updateCart(data) {
          this.show = false;
        },
      }, */
  methods: {
    userLogout () {
      console.log('-->> update-cart ')
      // At this stage we shoudl preobalby clear the cookie or something else
      // to make sure that it is not possible access,
      this.show = false
      //
    }
  },

  components: {
    CalendarTrips,
    Login,
    Main,
    VehicleSelect,
    MapFollow
  }
}
</script>
